'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Immutable = require('Immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return new _Immutable.List([{
    name: _I18n2.default.text('timezone_utils.timezones.pacific_time'),
    timezones: ['US/Pacific', 'America/Los_Angeles']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.mountain_time'),
    timezones: ['US/Mountain', 'America/Denver']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.central_time'),
    timezones: ['US/Central', 'America/Chicago']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.eastern_time'),
    timezones: ['US/Eastern', 'America/New_York']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.atlantic_time'),
    timezones: ['Canada/Atlantic']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.central_european_time'),
    timezones: ['Europe/Berlin', 'Africa/Lagos']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.eastern_european_time'),
    timezones: ['Europe/Athens']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.cities.dublin'), _I18n2.default.text('timezone_utils.cities.london'), _I18n2.default.text('timezone_utils.cities.lisbon')]),
    timezones: ['Europe/Dublin']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.eastern_carribean_time'),
    timezones: ['America/Barbados']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.countries.china'), _I18n2.default.text('timezone_utils.cities.hong_kong'), _I18n2.default.text('timezone_utils.cities.singapore')]),
    timezones: ['Asia/Shanghai']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.greenwich_mean_time'),
    timezones: ['Africa/Timbuktu']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.argentinian_time'),
    timezones: ['America/Argentina/Buenos_Aires']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.south_africa_time'),
    timezones: ['Africa/Johannesburg']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.east_africa_time'),
    timezones: ['Africa/Nairobi']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.cities.jamaica'), _I18n2.default.text('timezone_utils.cities.panama')]),
    timezones: ['America/Jamaica']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.indochina_time'),
    timezones: ['Asia/Bangkok']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.cities.new_delhi'), _I18n2.default.text('timezone_utils.cities.mumbai'), _I18n2.default.text('timezone_utils.cities.calcutta')]),
    timezones: ['Asia/Calcutta']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.arizona_time'),
    timezones: ['America/Phoenix']
  }, {
    name: _I18n2.default.text('timezone_utils.timezones.aed_time'),
    timezones: ['Australia/Canberra']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.cities.baghdad'), _I18n2.default.text('timezone_utils.cities.bahrain'), _I18n2.default.text('timezone_utils.cities.istanbul'), _I18n2.default.text('timezone_utils.cities.qatar')]),
    timezones: ['Asia/Baghdad']
  }, {
    name: _I18n2.default.formatList([_I18n2.default.text('timezone_utils.cities.seoul'), _I18n2.default.text('timezone_utils.cities.tokyo')]),
    timezones: ['Asia/Seoul']
  }]);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/lists/TimezoneAliases.js
// module id = 230
// module chunks = 0